import { useTranslation } from 'react-i18next';
import { ResetPasswordConfirmation } from 'src/components/login/screens/ResetPasswordConfirmation';
import { AccountType } from 'src/types';
import { ReportingResetConfirmationContainer } from './ReportingResetConfirmation.styles';

export const ReportingResetConfirmation = () => {
  const { t } = useTranslation();
  return (
    <ReportingResetConfirmationContainer>
      <ResetPasswordConfirmation
        headerText={t('reporting.ReportingLogin.passwordSuccessfullySetTitle')}
        successText={t(
          'reporting.ReportingLogin.passwordSuccessfullySetMessage',
        )}
        kind={AccountType.App}
      />
    </ReportingResetConfirmationContainer>
  );
};
